var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hot",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.763,
    height: 12.016,
    viewBox: "0 0 9.763 12.016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M4.881,12.016A4.859,4.859,0,0,1,0,7.134,2.7,2.7,0,0,1,.153,6.2a3.407,3.407,0,0,1,.375-.745q.223-.329.446-.716A3.9,3.9,0,0,0,1.349,3.72,6.306,6.306,0,0,0,1.5,2.253a.315.315,0,0,0,.123.229,2.387,2.387,0,0,0,.293.223,1.587,1.587,0,0,1,.375.393,2.47,2.47,0,0,1,.334.657,2.835,2.835,0,0,0,.61,1.038,1.213,1.213,0,0,0,.892.463,1.227,1.227,0,0,0,1.038-.692A5.3,5.3,0,0,0,5.8,2.7,15.794,15.794,0,0,0,6.008,0a4.962,4.962,0,0,0,.54,1.08A8.483,8.483,0,0,0,7.316,2.1q.4.458.851,1.044t.792,1.144a5.546,5.546,0,0,1,.575,1.3,5.227,5.227,0,0,1,.229,1.543,4.859,4.859,0,0,1-4.881,4.881Zm1.5-7.51A8.672,8.672,0,0,1,5.257,6.759a2.4,2.4,0,0,1-.557.5,5.393,5.393,0,0,1-.61.358,4.816,4.816,0,0,0-.534.305,1.229,1.229,0,0,0-.4.434A1.325,1.325,0,0,0,3,9.012a1.278,1.278,0,0,0,.557,1.109,2.231,2.231,0,0,0,1.32.393,2.937,2.937,0,0,0,1.877-.593A1.945,1.945,0,0,0,7.51,8.308a6.2,6.2,0,0,0-.129-1.355,3.037,3.037,0,0,0-.293-.845q-.164-.276-.375-.7A4.48,4.48,0,0,1,6.383,4.506Z",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/hot.bb227a2b70637fe2e9940cc75ce44601.svg";
export { ForwardRef as ReactComponent };